/**
 * The text of an API error. The API sends errors either as a string (`error: '...'`) or as an
 * object (`error: { code, message }`); passing the object to `new Error()` showed
 * "[object Object]" (e.g. on the sign-in page).
 */
export function apiErrorMessage(data: any, fallback: string): string {
  const err = data?.error;
  if (typeof err === 'string' && err.trim()) return err;
  if (err && typeof err === 'object' && typeof err.message === 'string' && err.message.trim()) return err.message;
  if (typeof data?.message === 'string' && data.message.trim()) return data.message;
  return fallback;
}
